import $date from '@/services/date'

export default function formatDateRelative(
  fromDate,
  toDate = new Date(),
  withoutSuffix = false
) {
  return $date(fromDate).from(toDate, withoutSuffix)
}
